var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmile = function SvgSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32 58c16.016 0 29-11.64 29-26S48.016 6 32 6 3 17.64 3 32s12.984 26 29 26M15.5 35a3.5 3.5 0 0 1 3.5 3.479C21.135 41.249 25.64 45 31.5 45c3.387 0 6.503-1.237 9.076-2.909 1.386-.9 2.57-1.898 3.507-2.83a3.5 3.5 0 1 1 4.438 2.588 26.8 26.8 0 0 1-5.222 4.435C40.164 48.321 36.113 50 31.5 50c-7.51 0-13.127-4.41-16.08-8a3.5 3.5 0 0 1 .08-7",
    clipRule: "evenodd"
  })));
};
export default SvgSmile;